import script from "./Wizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./Wizard.vue?vue&type=script&setup=true&lang=ts"

import "./Wizard.vue?vue&type=style&index=0&id=7a67d18e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a67d18e"]])

export default __exports__